export var SpecType;

(function (SpecType) {
  SpecType["COMPONENT_VIEW"] = "clickstream_component_view";
  SpecType["INTERACTION"] = "clickstream_interaction";
  SpecType["SIGN_IN"] = "clickstream_sign_in_start";
})(SpecType || (SpecType = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/utils/dist/esm/rio/types.js
// module id = 1626
// module chunks = 11